import { useCallback } from 'react';
import type { SubmitHandler } from 'react-hook-form';

import { useUserProfile } from 'contexts/UserProfileContext';

import type { EditUserFormValuesT } from '../declarations';

type useProfilePageT = {
  handleSubmitForm: SubmitHandler<EditUserFormValuesT>;
};

const useProfilePage = (): useProfilePageT => {
  /**
   * Hooks
   */
  const { updateUser } = useUserProfile();

  /**
   * Handlers
   */
  const handleSubmitForm = useCallback(
    (userData: EditUserFormValuesT) => {
      updateUser(userData);
    },
    [updateUser]
  );

  return {
    handleSubmitForm,
  };
};

export default useProfilePage;
